import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import FOG from 'vanta/dist/vanta.fog.min.js';

const VantaAurora = ({ children, className, style }) => {
  const myRef = useRef(null);
  const containerRef = useRef(null);
  const vantaEffectRef = useRef(null);

  useEffect(() => {
    if (!vantaEffectRef.current && myRef.current) {
      try {
        vantaEffectRef.current = FOG({
          el: myRef.current,
          THREE: THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          highlightColor: 0xedf7ef, // Xanh mint nhạt
          midtoneColor: 0xe6f5eb, // Xanh mint nhạt hơn chút
          lowlightColor: 0xffffff, // White
          baseColor: 0xffffff, // Pure white base
          blurFactor: 0.9,
          speed: 1.0,
          zoom: 1.0,
          minHeight: 200.00,
          minWidth: 200.00
        });
      } catch (err) {
        console.error("Vanta initialization failed", err);
      }
    }

    const resizeObserver = new ResizeObserver(() => {
      if (vantaEffectRef.current && typeof vantaEffectRef.current.resize === 'function') {
        vantaEffectRef.current.resize();
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
      if (vantaEffectRef.current) {
        try {
          vantaEffectRef.current.destroy();
          vantaEffectRef.current = null;
        } catch (e) {}
      }
    };
  }, []); // Run once on mount

  return (
    <div ref={containerRef} className={className} style={{ position: 'relative', overflow: 'hidden', ...style }}>
      <div ref={myRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }} />
      <div style={{ position: 'relative', zIndex: 1, width: '100%', height: '100%' }}>
        {children}
      </div>
    </div>
  );
};

export default VantaAurora;
